import { render, staticRenderFns } from "./CreateSubCategoryDialog.vue?vue&type=template&id=a44f4200&scoped=true"
import script from "@/views/Settings/Categories/CreateSubCategoryDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Categories/CreateSubCategoryDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Categories/create-subcategory-dialog.scss?vue&type=style&index=0&id=a44f4200&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44f4200",
  null
  
)

export default component.exports